<div class="reports-header">
  <div class="row" id="filter-row" [ngClass]="{'m-0': isFullWidth}">
    <div class="col-md-3" style="position: relative;" id="slider">
       <app-slider *ngIf="styleFlag" [value]="filterPreference.sliderValue" (onChangeValue)="changeValue($event)"></app-slider>
    </div>

    <div class="col-md-9 right top-actions" id="filter-options"
      [ngClass]="{'pr-0': isFullWidth}">
      <!-- Selected Filter -->
      <div *ngIf="preferences?.length > 0" class="btn-group" dropdown #filterDropdownPreference="bs-dropdown" (click)="filterDropdown.hide(); filterDropdownSort.hide();">
        <button type="button" class="btn btn-rbv btn-rbv-dropdown small" dropdownToggle [disabled]="reportsLoading">
          <fa name="fa fa-save"></fa>
          Selected Filter: {{clearFilterFieldName()}}
          <fa name="fa fa-chevron-down"></fa>
        </button>

        <div *dropdownMenu class="drop-menu" style="width: 250px;">
          <a class="drop-item" (click)="clearFilterBy('NO_SELECTED')">
            <fa class="check-block" name="fa fa-bars" style="width: 20px;"></fa>
            <div class="item">Clear Selected Filter</div>
          </a>

          <div *ngFor="let p of preferences; let x=index;" class="drop-item">

            <label class="checkbox">
              <input type="checkbox" class="checkbox__input" [value]="true" name="selectFilter" id="selectFilter_{{x}}"
                [(ngModel)]="p.SELECTED" (ngModelChange)="onFilterValueChanged(p, $event)"
                [disabled]="reportsLoading" [checked]="p.SELECTED === true" >
                <div class="checkbox__data pl-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text" style="width: 150px;">{{p?.NAME}}</p>
                </div>
              </label>

            <button type="button" class="close" aria-label="Close" (click)="deleteFilter(p)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>

      <div class="btn-group" (click)="clearFilterBy('NO_SELECTED')" *ngIf="!preferenceSelected()">
        <button type="button" class="btn btn-rbv warning btn-rbv-dropdown small" [disabled]="reportsLoading">
          {{clearFilterFieldName()}}
          <fa name="fa fa-times"></fa>
        </button>
      </div>

      <!-- Filtered By Dropdown -->
      <div class="btn-group" dropdown #filterDropdown="bs-dropdown" (click)="preventClose($event); closeFilterDropDown(); filterDropdownSort.hide();">
        <button type="button" class="btn btn-rbv btn-rbv-dropdown small" dropdownToggle [disabled]="reportsLoading">
          <fa name="fa fa-filter"></fa>
          <!-- Filtered by: {{getFilterFieldName()}} -->
          Filtered by: {{getFilterFieldText()}}
          <fa name="fa fa-chevron-down"></fa>
        </button>

        <div *dropdownMenu class="drop-menu" style="width: 250px;">
          <!-- No Filter -->
          <a class="drop-item" [ngClass]="{'menu-disabled': reportsLoading}"
            (click)="reportsLoading ? '' : setFilterBy('NO_FILTER');">
            <fa class="check-block" name="fa fa-bars" style="width: 20px;"></fa>
            <div class="item">No Filter</div>
          </a>

          <!-- State -->
          <div class="drop-item parent-menu" *ngIf="showStates"
            [ngClass]="{'auto-height': filterPreference?.selectedStates.length > 0, 'menu-disabled': reportsLoading}">
            <!-- When Filtered with State-->
            <div *ngIf="filterPreference?.selectedStates.length > 0" class="info">
              <div class="label">State: </div>

              <!-- Scroll Top button -->
              <div class="text-center mb-2 mt-2" *ngIf="filterPreference?.selectedStates.length > 5 && filterLimit.state.min > 0">
                <button type="button" class="btn btn-rbv filterBtn filterBtn" (click)="scrollFilter('state', true)">
                  <i class="fa fa-chevron-up"></i>
                </button>
              </div>

              <!-- Selected States -->
              <div *ngFor="let s of filterPreference?.selectedStates| slice:filterLimit.state.min:filterLimit.state.max;" class="name">
                <div class="avatar mb-2">
                  <ngx-avatar [name]="s.NAME" size="20"></ngx-avatar>
                  <span class="item">{{ s.NAME }}</span>
                </div>
                <button type="button" class="close" aria-label="Close" (click)="clearState(s, 'STATE')"
                  [disabled]="reportsLoading">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <!-- Scroll Bottom button -->
              <div class="text-center"
                *ngIf="filterPreference?.selectedStates.length > 5 && (filterLimit.state.max < filterPreference?.selectedStates.length)">
                <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('state', false)">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </div>
            </div>

            <!-- When Not Filtered with State-->
            <ng-container *ngIf="!filterPreference?.selectedStates.length > 0">
              <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
              <div class="item">State</div>
            </ng-container>

            <!-- Filter Options -->
            <div class="drop-menu sub-menu">
              <div *ngFor="let state of states; let x=index;" class="drop-item">

                <label class="checkbox">
                  <input type="checkbox" class="checkbox__input" [value]="true" name="selectState" id="selectState_{{x}}"
                  [(ngModel)]="state.selected" (ngModelChange)="onStateValueChanged(state, $event)"
                  [disabled]="reportsLoading" [checked]="state.selected === true" >
                  <div class="checkbox__data pl-0">
                    <div class="checkbox__indicator"></div>
                    <p class="checkbox__text">{{state?.NAME}}</p>
                  </div>
                </label>

              </div>
            </div>
          </div>

          <!-- Stage -->
          <div class="drop-item parent-menu" *ngIf="showStages"
            [ngClass]="{'auto-height': filterPreference?.selectedStages.length > 0, 'menu-disabled': reportsLoading}">
            <!-- When Filtered with Stage -->
            <div *ngIf="filterPreference?.selectedStages.length > 0" class="info">
              <div class="label">Stage: </div>

              <!-- Scroll Top button -->
              <div class="text-center mb-2 mt-2" *ngIf="filterPreference?.selectedStages.length > 5 && filterLimit.stage.min > 0">
                <button type="button" class="btn btn-rbv filterBtn filterBtn" (click)="scrollFilter('stage', true)">
                  <i class="fa fa-chevron-up"></i>
                </button>
              </div>

              <!-- Selected Stages -->
              <div *ngFor="let s of filterPreference?.selectedStages| slice:filterLimit.stage.min:filterLimit.stage.max;"
                class="name mb-2">
                <div class="avatar">
                  <ngx-avatar [value]="getAvatarLetters(s?.NAME)" size="20"></ngx-avatar>
                  <span class="item">{{ s.NAME }}</span>
                </div>
                <button type="button" class="close" aria-label="Close" (click)="clearStage(s, 'STAGE')"
                  [disabled]="reportsLoading">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <!-- Scroll Bottom button -->
              <div class="text-center"
                *ngIf="filterPreference?.selectedStages.length > 5 && (filterLimit.stage.max < filterPreference?.selectedStages.length)">
                <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('stage', false)">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </div>
            </div>

            <!-- When Not Filtered with Stage -->
            <ng-container *ngIf="!filterPreference?.selectedStages.length > 0">
              <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
              <div class="item">Stage</div>
            </ng-container>

            <!-- Filter Options -->
            <div class="drop-menu sub-menu" style="width: 280px">
              <div *ngFor="let stage of stages; let x=index;" class="drop-item">

                <label class="checkbox" *ngIf="stage.TYPE == currentMode">
                  <input type="checkbox" class="checkbox__input" [value]="true" name="selectStage" id="selectStage_{{x}}"
                  [(ngModel)]="stage.selected" (ngModelChange)="onStageValueChanged(stage, $event)"
                  [disabled]="reportsLoading" [checked]="stage.selected === true" >
                  <div class="checkbox__data pl-0">
                    <div class="checkbox__indicator"></div>
                    <p class="checkbox__text">{{stage?.NAME}}</p>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <!-- Assignee -->
          <div class="drop-item parent-menu"
            [ngClass]="{'auto-height': filterPreference?.selectedAssignee.length > 0, 'menu-disabled': reportsLoading}">
            <!-- When Filtered with Assignee -->
            <div *ngIf="filterPreference?.selectedAssignee.length > 0" class="info" (mouseover)="onloadAssignee($event)">
              <div class="label">Assignee: </div>

              <!-- Scroll Top button -->
              <div class="text-center mb-2 mt-2" *ngIf="filterPreference?.selectedAssignee.length > 5 && filterLimit.assignee.min > 0">
                <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('assignee', true)">
                  <i class="fa fa-chevron-up"></i>
                </button>
              </div>

              <!-- Selected Assignee -->
              <div *ngFor="let u of filterPreference?.selectedAssignee | slice:filterLimit.assignee.min:filterLimit.assignee.max;"
                class="name mb-2">
                <div class="avatar">
                  <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                  <span
                    class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                </div>
                <button type="button" class="close" aria-label="Close" (click)="clearAssignee(u, 'ASSIGNEE')"
                  [disabled]="reportsLoading">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <!-- Scroll Bottom button -->
              <div class="text-center"
                *ngIf="filterPreference?.selectedAssignee.length > 5 && (filterLimit.assignee.max < filterPreference?.selectedAssignee.length)">
                <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('assignee', false)">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </div>
            </div>

            <!-- When Not Filtered with Assignee -->
            <ng-container *ngIf="!filterPreference?.selectedAssignee.length > 0">
              <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
              <div class="item" (mouseover)="onloadAssignee($event)">Assignee</div>
            </ng-container>

            <!-- Filter Options -->
            <div class="drop-menu sub-menu" style="width: 280px">
              <div class="item-input">
                <label class="rbv-label">Filter by Assignee</label>
                <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                  (searchTriggered)="onUserResult($event)" [disabled]="reportsLoading"></input-search>
              </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                   <div class="item-user" *ngFor="let user of searchUsers"
                     (click)="reportsLoading ? '' : selectFilterAssignee(user);"
                     [ngClass]="{'menu-disabled': reportsLoading}">
                     <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                     <div class="user-name">{{user.getName()}}</div>
                   </div>
                </ng-container>

            </div>
          </div>

          <!-- Filters for BV -->
          <ng-container *ngIf="currentMode === Mode.BV">
            <!--Processor-->
            <div class="drop-item parent-menu"
              [ngClass]="{'auto-height': filterPreference?.selectedProcessor.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Processor -->
              <div *ngIf="filterPreference?.selectedProcessor.length > 0" class="info"
                (mouseover)="onloadProcessor($event)">
                <div class="label">Processor: </div>

                <!-- Scroll Top button -->
                <div class="text-center mb-2 mt-2"
                  *ngIf="filterPreference?.selectedProcessor.length > 5 && filterLimit.processor.min > 0">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('processor', true)">
                    <i class="fa fa-chevron-up"></i>
                  </button>
                </div>

                <!-- Selected Processor -->
                <div
                  *ngFor="let u of filterPreference?.selectedProcessor | slice:filterLimit.processor.min:filterLimit.processor.max;"
                  class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                    <span
                      class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close" (click)="clearProcessor(u, 'PROGRESSOR')"
                    [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Scroll Bottom button -->
                <div class="text-center"
                  *ngIf="filterPreference?.selectedProcessor.length > 5 && (filterLimit.processor.max < filterPreference?.selectedProcessor.length)">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('processor', false)">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Processor -->
              <ng-container *ngIf="!filterPreference?.selectedProcessor.length > 0">
                <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
                <div class="item" (mouseover)="onloadProcessor($event)">Processor</div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div class="item-input">
                  <label class="rbv-label">Filter by Processor</label>
                  <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                    (searchTriggered)="onUserResult($event, 'PROCESSOR')" [disabled]="reportsLoading"></input-search>
                </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                  <div class="item-user" *ngFor="let user of searchProcessor"
                    (click)="reportsLoading ? '' : selectFilterProcessor(user);"
                    [ngClass]="{'menu-disabled': reportsLoading}">
                    <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                    <div class="user-name">{{user.getName()}}</div>
                  </div>
                </ng-container>

              </div>
            </div>

            <!-- Research Analyst -->
            <div class="drop-item parent-menu"
              [ngClass]="{'auto-height': filterPreference?.selectedResearchAnalyst.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Research Analyst -->
              <div *ngIf="filterPreference?.selectedResearchAnalyst.length > 0" class="info"
                (mouseover)="onloadResearchAnalyst($event)">
                <div class="label">Research Analyst: </div>
                <!-- Scroll Top button -->
                <div class="text-center mb-2 mt-2"
                  *ngIf="filterPreference?.selectedResearchAnalyst.length > 5 && filterLimit.researchAnalyst.min > 0">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('researchAnalyst', true)">
                    <i class="fa fa-chevron-up"></i>
                  </button>
                </div>

                <!-- Selected Research Analyst -->
                <div
                  *ngFor="let u of filterPreference?.selectedResearchAnalyst| slice:filterLimit.researchAnalyst.min:filterLimit.researchAnalyst.max;"
                  class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                    <span
                      class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close"
                    (click)="clearResearchAnalyst(u, 'RESEARCH_ANALYST')" [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Scroll Bottom button -->
                <div class="text-center"
                  *ngIf="filterPreference?.selectedResearchAnalyst.length > 5 && (filterLimit.researchAnalyst.max < filterPreference?.selectedResearchAnalyst.length)">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('researchAnalyst', false)">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Research Analyst -->
              <ng-container *ngIf="!filterPreference?.selectedResearchAnalyst.length > 0">
                <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
                <div class="item" (mouseover)="onloadResearchAnalyst($event)">Research Analyst</div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div class="item-input">
                  <label class="rbv-label">Filter by Research Analyst</label>
                  <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                    (searchTriggered)="onUserResult($event, 'RESEARCH_ANALYST')" [disabled]="reportsLoading">
                  </input-search>
                </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                  <div class="item-user" *ngFor="let user of searchResearchAnalyst"
                    (click)="reportsLoading ? '' : selectFilterResearchAnalyst(user);"
                    [ngClass]="{'menu-disabled': reportsLoading}">
                    <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                    <div class="user-name">{{user.getName()}}</div>
                  </div>
                </ng-container>

              </div>
            </div>

            <!-- Financial Analyst -->
            <div class="drop-item parent-menu"
              [ngClass]="{'auto-height': filterPreference?.selectedFinancialAnalyst.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Financial Analyst -->
              <div *ngIf="filterPreference?.selectedFinancialAnalyst.length > 0" class="info"
                (mouseover)="onloadFinancialAnalyst($event)">
                <div class="label">Financial Analyst: </div>

                <!-- Scroll Top button -->
                <div class="text-center mb-2 mt-2"
                  *ngIf="filterPreference?.selectedFinancialAnalyst.length > 5 && filterLimit.financialAnalyst.min > 0">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('financialAnalyst', true)">
                    <i class="fa fa-chevron-up"></i>
                  </button>
                </div>

                <!-- Selected Financial Analyst -->
                <div
                  *ngFor="let u of filterPreference?.selectedFinancialAnalyst| slice:filterLimit.financialAnalyst.min:filterLimit.financialAnalyst.max;"
                  class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                    <span
                      class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close"
                    (click)="clearFinancialAnalyst(u, 'FINANCIAL_ANALYST')" [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Scroll Bottom button -->
                <div class="text-center"
                  *ngIf="filterPreference?.selectedFinancialAnalyst.length > 5 && (filterLimit.financialAnalyst.max < filterPreference?.selectedFinancialAnalyst.length)">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('financialAnalyst', false)">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Financial Analyst -->
              <ng-container *ngIf="!filterPreference?.selectedFinancialAnalyst.length > 0">
                <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
                <div class="item" (mouseover)="onloadFinancialAnalyst($event)">Financial Analyst</div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div class="item-input">
                  <label class="rbv-label">Filter by Financial Analyst</label>
                  <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                    (searchTriggered)="onUserResult($event, 'FINANCIAL_ANALYST')" [disabled]="reportsLoading">
                  </input-search>
                </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                  <div class="item-user" *ngFor="let user of searchFinancialAnalyst"
                    (click)="reportsLoading ? '' : selectFilterFinancialAnalyst(user);"
                    [ngClass]="{'menu-disabled': reportsLoading}">
                    <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                    <div class="user-name">{{user.getName()}}</div>
                  </div>
                </ng-container>

              </div>
            </div>

            <!-- Senior Analyst -->
            <div class="drop-item parent-menu"
              [ngClass]="{'auto-height': filterPreference?.selectedSeniorAnalyst.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Senior Analyst -->
              <div *ngIf="filterPreference?.selectedSeniorAnalyst.length > 0" class="info"
                (mouseover)="onloadSeniorAnalyst($event)">
                <div class="label">Senior Analyst: </div>
                <!-- Scroll Top button -->
                <div class="text-center mb-2 mt-2"
                  *ngIf="filterPreference?.selectedSeniorAnalyst.length > 5 && filterLimit.seniorAnalyst.min > 0">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('seniorAnalyst', true)">
                    <i class="fa fa-chevron-up"></i>
                  </button>
                </div>

                <!-- Selected Senior Analyst -->
                <div
                  *ngFor="let u of filterPreference?.selectedSeniorAnalyst | slice:filterLimit.seniorAnalyst.min:filterLimit.seniorAnalyst.max;"
                  class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                    <span
                      class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close"
                    (click)="clearSeniorAnalyst(u, 'SENIOR_ANALYST')" [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Scroll Bottom button -->
                <div class="text-center"
                  *ngIf="filterPreference?.selectedSeniorAnalyst.length > 5 && (filterLimit.seniorAnalyst.max < filterPreference?.selectedSeniorAnalyst.length)">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('seniorAnalyst', false)">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Senior Analyst -->
              <ng-container *ngIf="!filterPreference?.selectedSeniorAnalyst.length > 0">
                <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
                <div class="item" (mouseover)="onloadSeniorAnalyst($event)">Senior Analyst</div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div class="item-input">
                  <label class="rbv-label">Filter by Senior Analyst</label>
                  <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                    (searchTriggered)="onUserResult($event, 'SENIOR_ANALYST')" [disabled]="reportsLoading">
                  </input-search>
                </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                  <div class="item-user" *ngFor="let user of searchSeniorAnalyst"
                    (click)="reportsLoading ? '' : selectFilterSeniorAnalyst(user)"
                    [ngClass]="{'menu-disabled': reportsLoading}">
                    <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                    <div class="user-name">{{user.getName()}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <!-- Filters for EA -->
          <ng-container *ngIf="currentMode === Mode.EA">
            <!--Equipment Processor-->
            <div class="drop-item parent-menu"
              [ngClass]="{'auto-height': filterPreference?.selectedEaProcessor.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Processor -->
              <div *ngIf="filterPreference?.selectedEaProcessor.length > 0" class="info"
                (mouseover)="onloadEquipmentProcessor($event)">
                <div class="label">Equipment Processor: </div>

                <!-- Scroll Top button -->
                <div class="text-center mb-2 mt-2"
                  *ngIf="filterPreference?.selectedEaProcessor.length > 5 && filterLimit.eqprocessor.min > 0">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('eqprocessor', true)">
                    <i class="fa fa-chevron-up"></i>
                  </button>
                </div>

                <!-- Selected Processor -->
                <div
                  *ngFor="let u of filterPreference?.selectedEaProcessor | slice:filterLimit.eqprocessor.min:filterLimit.eqprocessor.max;"
                  class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                    <span
                      class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close" (click)="clearEProcessor(u, 'EQUIPMENT_PROCESSOR')"
                    [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Scroll Bottom button -->
                <div class="text-center"
                  *ngIf="filterPreference?.selectedEaProcessor.length > 5 && (filterLimit.eqprocessor.max < filterPreference?.selectedEaProcessor.length)">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('eqprocessor', false)">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Processor -->
              <ng-container *ngIf="!filterPreference?.selectedEaProcessor.length > 0">
                <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
                <div class="item" (mouseover)="onloadEquipmentProcessor($event)">Equipment Processor</div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div class="item-input">
                  <label class="rbv-label">Filter by Equipment Processor</label>
                  <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                    (searchTriggered)="onUserResult($event, 'EQUIPMENT_PROCESSOR')" [disabled]="reportsLoading"></input-search>
                </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                  <div class="item-user" *ngFor="let user of searchEaProcessor"
                    (click)="reportsLoading ? '' : selectFilterEqProcessor(user);"
                    [ngClass]="{'menu-disabled': reportsLoading}">
                    <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                    <div class="user-name">{{user.getName()}}</div>
                  </div>
                </ng-container>

              </div>
            </div>

            <!-- Equipment Research Analyst -->
            <div class="drop-item parent-menu"
              [ngClass]="{'auto-height': filterPreference?.selectedEaResearchAnalyst.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Research Analyst -->
              <div *ngIf="filterPreference?.selectedEaResearchAnalyst.length > 0" class="info"
                (mouseover)="onloadEquipmentResearchAnalyst($event)">
                <div class="label">Equipment Research Analyst: </div>
                <!-- Scroll Top button -->
                <div class="text-center mb-2 mt-2"
                  *ngIf="filterPreference?.selectedEaResearchAnalyst.length > 5 && filterLimit.eqresearchAnalyst.min > 0">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('eqresearchAnalyst', true)">
                    <i class="fa fa-chevron-up"></i>
                  </button>
                </div>

                <!-- Selected Research Analyst -->
                <div
                  *ngFor="let u of filterPreference?.selectedEaResearchAnalyst| slice:filterLimit.eqresearchAnalyst.min:filterLimit.eqresearchAnalyst.max;"
                  class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                    <span
                      class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close"
                    (click)="clearEqResearchAnalyst(u, 'EQUIPMENT_RESEARCH_ANALYST')" [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Scroll Bottom button -->
                <div class="text-center"
                  *ngIf="filterPreference?.selectedEaResearchAnalyst.length > 5 && (filterLimit.eqresearchAnalyst.max < filterPreference?.selectedEaResearchAnalyst.length)">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('eqresearchAnalyst', false)">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Research Analyst -->
              <ng-container *ngIf="!filterPreference?.selectedEaResearchAnalyst.length > 0">
                <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
                <div class="item" (mouseover)="onloadEquipmentResearchAnalyst($event)">Equipment Research Analyst</div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div class="item-input">
                  <label class="rbv-label">Filter by Equipment Research Analyst</label>
                  <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                    (searchTriggered)="onUserResult($event, 'EQUIPMENT_RESEARCH_ANALYST')" [disabled]="reportsLoading">
                  </input-search>
                </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                  <div class="item-user" *ngFor="let user of searchEaResearchAnalyst"
                    (click)="reportsLoading ? '' : selectFilterEqResearchAnalyst(user);"
                    [ngClass]="{'menu-disabled': reportsLoading}">
                    <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                    <div class="user-name">{{user.getName()}}</div>
                  </div>
                </ng-container>

              </div>
            </div>

            <!-- Equipment Appraiser -->
            <div class="drop-item parent-menu"
              [ngClass]="{'auto-height': filterPreference?.selectedEaAppraiser.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Financial Analyst -->
              <div *ngIf="filterPreference?.selectedEaAppraiser.length > 0" class="info"
                (mouseover)="onloadEquipmentAppraiser($event)">
                <div class="label">Equipment Appraiser: </div>

                <!-- Scroll Top button -->
                <div class="text-center mb-2 mt-2"
                  *ngIf="filterPreference?.selectedEaAppraiser.length > 5 && filterLimit.eqAppraiser.min > 0">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('eqAppraiser', true)">
                    <i class="fa fa-chevron-up"></i>
                  </button>
                </div>

                <!-- Selected Financial Analyst -->
                <div
                  *ngFor="let u of filterPreference?.selectedEaAppraiser| slice:filterLimit.eqAppraiser.min:filterLimit.eqAppraiser.max;"
                  class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                    <span
                      class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close"
                    (click)="clearEqAppraiser(u, 'EQUIPMENT_APPRAISER')" [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Scroll Bottom button -->
                <div class="text-center"
                  *ngIf="filterPreference?.selectedEaAppraiser.length > 5 && (filterLimit.eqAppraiser.max < filterPreference?.selectedEaAppraiser.length)">
                  <button type="button" class="btn btn-rbv filterBtn"
                    (click)="scrollFilter('eqAppraiser', false)">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Financial Analyst -->
              <ng-container *ngIf="!filterPreference?.selectedEaAppraiser.length > 0">
                <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
                <div class="item" (mouseover)="onloadEquipmentAppraiser($event)">Equipment Appraiser</div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div class="item-input">
                  <label class="rbv-label">Filter by Equipment Appraiser</label>
                  <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                    (searchTriggered)="onUserResult($event, 'EQUIPMENT_APPRAISER')" [disabled]="reportsLoading">
                  </input-search>
                </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                  <div class="item-user" *ngFor="let user of searchEaAppraiser"
                    (click)="reportsLoading ? '' : selectFilterEqAppraiser(user);"
                    [ngClass]="{'menu-disabled': reportsLoading}">
                    <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                    <div class="user-name">{{user.getName()}}</div>
                  </div>
                </ng-container>

              </div>
            </div>

            <!-- Equipment Reviewer -->
            <div class="drop-item parent-menu"
              [ngClass]="{'auto-height': filterPreference?.selectedEaReviewer.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Senior Analyst -->
              <div *ngIf="filterPreference?.selectedEaReviewer.length > 0" class="info"
                (mouseover)="onloadEquipmentReviewer($event)">
                <div class="label">Equipment Reviewer: </div>
                <!-- Scroll Top button -->
                <div class="text-center mb-2 mt-2"
                  *ngIf="filterPreference?.selectedEaReviewer.length > 5 && filterLimit.eqReviewer.min > 0">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('eqReviewer', true)">
                    <i class="fa fa-chevron-up"></i>
                  </button>
                </div>

                <!-- Selected Senior Analyst -->
                <div
                  *ngFor="let u of filterPreference?.selectedEaReviewer | slice:filterLimit.eqReviewer.min:filterLimit.eqReviewer.max;"
                  class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="u.getName()" size="20"></ngx-avatar>
                    <span
                      class="item">{{ (u.FIRST_NAME ? u.FIRST_NAME : '') + (u.FIRST_NAME ? ' ': '') + (u.LAST_NAME ? u.LAST_NAME : '')}}{{((!u.FIRST_NAME && !u.LAST_NAME) ? u.EMAIL : '')}}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close"
                    (click)="clearEqReviwer(u, 'EQUIPMENT_REVIEWER')" [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!-- Scroll Bottom button -->
                <div class="text-center"
                  *ngIf="filterPreference?.selectedEaReviewer.length > 5 && (filterLimit.eqReviewer.max < filterPreference?.selectedEaReviewer.length)">
                  <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('eqReviewer', false)">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Senior Analyst -->
              <ng-container *ngIf="!filterPreference?.selectedEaReviewer.length > 0">
                <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
                <div class="item" (mouseover)="onloadEquipmentReviewer($event)">Equipment Reviewer</div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div class="item-input">
                  <label class="rbv-label">Filter by Equipment Reviewer</label>
                  <input-search [provider]="userProvider" [no-drop-icon]="true" placeholder="Search"
                    (searchTriggered)="onUserResult($event, 'EQUIPMENT_REVIEWER')" [disabled]="reportsLoading">
                  </input-search>
                </div>

                <loader [loading]="loading"></loader>

                <ng-container *ngIf="!loading">
                  <div class="item-user" *ngFor="let user of searchEaReviewer"
                    (click)="reportsLoading ? '' : selectFilterEqReviewer(user)"
                    [ngClass]="{'menu-disabled': reportsLoading}">
                    <ngx-avatar [name]="user.getName()" size="25"></ngx-avatar>
                    <div class="user-name">{{user.getName()}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <!-- Bank -->
          <div class="drop-item parent-menu"
            [ngClass]="{'auto-height': filterPreference?.selectedBanks.length > 0, 'menu-disabled': reportsLoading}">
            <!-- When Filtered with Bank -->
            <div *ngIf="filterPreference?.selectedBanks.length > 0" class="info" (mouseover)="onLoadBanks($event)">
              <div class="label">Bank: </div>
              <!-- Scroll Top button -->
              <div class="text-center mb-2 mt-2" *ngIf="filterPreference?.selectedBanks.length > 5 && filterLimit.bank.min > 0">
                <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('bank', true)">
                  <i class="fa fa-chevron-up"></i>
                </button>
              </div>

              <!-- Selected Banks -->
              <div *ngFor="let b of filterPreference?.selectedBanks| slice:filterLimit.bank.min:filterLimit.bank.max;" class="name">
                <div class="avatar mb-2">
                  <ngx-avatar [name]="b.getName()" size="20"></ngx-avatar>
                  <span class="item">{{b.COMPANY_NAME }}</span>
                </div>
                <button type="button" class="close" aria-label="Close" (click)="clearBank(b, 'BANK')"
                  [disabled]="reportsLoading">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <!-- Scroll Bottom button -->
              <div class="text-center"
                *ngIf="filterPreference?.selectedBanks.length > 5 && (filterLimit.bank.max < filterPreference?.selectedBanks.length)">
                <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('bank', false)">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </div>
            </div>

            <!-- When Not Filtered with Bank -->
            <ng-container *ngIf="!filterPreference?.selectedBanks.length > 0">
              <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
              <div class="item" (mouseover)="onLoadBanks($event)">Bank</div>
            </ng-container>

            <!-- Filter Options -->
            <div class="drop-menu sub-menu" style="width: 280px">
              <div class="item-input">
                <label class="rbv-label">Filter by Bank</label>
                <input-search placeholder="Search" (searchTriggered)="onBankResult($event)" [provider]="clientProvider"
                  [no-drop-icon]="true" [disabled]="reportsLoading"></input-search>
              </div>

               <loader [loading]="loading"></loader>

               <ng-container *ngIf="!loading">
                 <div class="item-user" *ngFor="let bank of searchBanks"
                   (click)="reportsLoading ? '' : selectFilterBank(bank)" [ngClass]="{'menu-disabled': reportsLoading}">
                   <ngx-avatar [name]="bank.getName()" size="25"></ngx-avatar>
                   <div class="user-name">{{bank.getName()}}</div>
                 </div>
              </ng-container>

            </div>
          </div>

          <!-- Delay -->
          <div class="drop-item parent-menu"
            [ngClass]="{'auto-height': filterPreference?.selectedDelay, 'menu-disabled': reportsLoading}">
            <!-- Selected Delay list -->
            <div *ngIf="filterPreference?.selectedDelay" class="info">
              <div class="label">Delay: </div>

              <div class="name">
                <div class="avatar mb-2">
                  <ngx-avatar [name]="getDelayName()" size="20"></ngx-avatar>
                  <span class="item">{{ getDelayName() }}</span>
                </div>
                <button type="button" class="close" aria-label="Close" (click)="clearDelay()"
                  [disabled]="reportsLoading">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>

            <!-- When Delay not Selected -->
            <ng-container *ngIf="!filterPreference?.selectedDelay">
              <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
              <div class="item">Delay</div>
            </ng-container>

            <!-- Filter options -->
            <div class="drop-menu sub-menu">
              <div class="drop-item">
                <label class="checkbox">
                  <input type="radio" class="checkbox__input" [value]="DelayType.CLIENT" name="selectedDelay" id="delayClient"
                    [(ngModel)]="filterPreference.selectedDelay" (ngModelChange)="setDelay($event)"
                    [disabled]="reportsLoading" [checked]="filterPreference.selectedDelay === DelayType.CLIENT">
                    <div class="checkbox__data pl-0">
                      <div class="checkbox__indicator"></div>
                      <p class="checkbox__text">Had Client Delay</p>
                    </div>
                </label>
              </div>

              <div class="drop-item">
                <label class="checkbox">
                  <input type="radio" class="checkbox__input" [value]="DelayType.RELIANT" name="selectedDelay" id="delayReliant"
                    [(ngModel)]="filterPreference.selectedDelay" (ngModelChange)="setDelay($event)"
                    [disabled]="reportsLoading" [checked]="filterPreference.selectedDelay === DelayType.RELIANT">
                    <div class="checkbox__data pl-0">
                      <div class="checkbox__indicator"></div>
                      <p class="checkbox__text">Had Reliant Delay</p>
                    </div>
                </label>
              </div>

              <div class="drop-item">
                <label class="checkbox">
                  <input type="radio" class="checkbox__input" [value]="DelayType.CURRENT" name="selectedDelay" id="delayCurrent"
                    [(ngModel)]="filterPreference.selectedDelay" (ngModelChange)="setDelay($event)"
                    [disabled]="reportsLoading" [checked]="filterPreference.selectedDelay === DelayType.CURRENT">
                    <div class="checkbox__data pl-0">
                      <div class="checkbox__indicator"></div>
                      <p class="checkbox__text">Currently on Delay</p>
                    </div>
                </label>
              </div>
            </div>
          </div>

          <!-- Tags -->
          <div class="drop-item parent-menu"
            [ngClass]="{'auto-height': filterPreference?.selectedTags.length > 0, 'menu-disabled': reportsLoading}">
            <!-- When Filtered with Tags -->
            <div *ngIf="filterPreference?.selectedTags.length > 0" class="info" (mouseover)="onLoadTags($event)">
              <div class="label">Tags: </div>
              <!-- Scroll Top button -->
              <div class="text-center mb-2 mt-2"
                *ngIf="filterPreference?.selectedTags.length > 5 && filterLimit.tags.min > 0">
                <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('tags', true)">
                  <i class="fa fa-chevron-up"></i>
                </button>
              </div>

              <!-- Selected Tags -->
              <div *ngFor="let tag of filterPreference?.selectedTags| slice:filterLimit.tags.min:filterLimit.tags.max;"
                class="name">
                <div class="avatar mb-2">
                  <ngx-avatar [name]="tag.NAME" size="20"></ngx-avatar>
                  <span class="item">{{tag.NAME }}</span>
                </div>
                <button type="button" class="close" aria-label="Close" (click)="clearTags(tag, 'TAGS')"
                  [disabled]="reportsLoading">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <!-- Scroll Bottom button -->
              <div class="text-center"
                *ngIf="filterPreference?.selectedTags.length > 5 && (filterLimit.tags.max < filterPreference?.selectedTags.length)">
                <button type="button" class="btn btn-rbv filterBtn" (click)="scrollFilter('tags', false)">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </div>
            </div>

            <!-- When Not Filtered with Tags -->
            <ng-container *ngIf="!filterPreference?.selectedTags.length > 0">
              <fa class="check-block" name="fa fa-user-circle" style="width: 20px;"></fa>
              <div class="item" (mouseover)="onLoadTags($event)">Tags</div>
            </ng-container>

            <!-- Filter Options -->
            <div class="drop-menu sub-menu" style="width: 280px;">
              <div class="item-input">
                <label class="rbv-label">Filter by Tags</label>
                <input-search placeholder="Search" (searchTriggered)="onTagResult($event)" [provider]="tagProvider"
                  [no-drop-icon]="true" [disabled]="reportsLoading"></input-search>
              </div>

              <loader [loading]="loading"></loader>

              <ng-container *ngIf="!loading">
                <div class="item-user" *ngFor="let tag of searchTags"
                  (click)="reportsLoading ? '' : selectFilterTags(tag)" [ngClass]="{'menu-disabled': reportsLoading}">
                  <ngx-avatar [name]="tag.getName()" size="25"></ngx-avatar>
                  <div class="user-name">{{tag.getName()}}</div>
                </div>
              </ng-container>

            </div>
          </div>

          <!--Miscs-->
          <ng-container>
            <div class="drop-item parent-menu" [ngClass]="{'auto-height': filterPreference?.selectedMiscs.length > 0, 'menu-disabled': reportsLoading}">
              <!-- When Filtered with Draw -->
              <div *ngIf="filterPreference?.selectedMiscs.length > 0" class="info">
                <div class="label">Misc: </div>

                <!-- Selected Draw -->
                <div *ngFor="let s of filterPreference?.selectedMiscs" class="name mb-2">
                  <div class="avatar">
                    <ngx-avatar [name]="s.NAME" size="20"></ngx-avatar>
                    <span class="item">{{ s.NAME }}</span>
                  </div>
                  <button type="button" class="close" aria-label="Close" (click)="clearMiscs(s, 'MISC')" [disabled]="reportsLoading">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <!-- When Not Filtered with Draw -->
              <ng-container *ngIf="filterPreference?.selectedMiscs.length == 0">
                <i class="fa fa-user-circle" style="width: 20px;"></i>
                <div class="item">Misc </div>
              </ng-container>

              <!-- Filter Options -->
              <div class="drop-menu sub-menu" style="width: 280px">
                <div *ngFor="let p of miscs; let x=index;" class="drop-item">
                  <input class="checkbox-custom" style="margin: 0;" [(ngModel)]="p.selected"
                         (ngModelChange)="onMiscValueChanged(p, $event)" [disabled]="reportsLoading" type='checkbox'
                         name="selectedMisc" id="selectedMisc_{{x}}" [value]="true" [checked]="p.selected === true" />
                  <label class="checkbox-custom-label ellipsis" style="margin: 0; width: 100%;" for="selectedMisc_{{x}}">
                    {{p.NAME}}</label>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Order By Dropdown -->
      <div class="btn-group" dropdown #filterDropdownSort="bs-dropdown" (click)="filterDropdown.hide(); closeFilterDropDown();">
        <button type="button" class="btn btn-rbv btn-rbv-dropdown small" dropdownToggle [disabled]="reportsLoading">
          <fa name="fa fa-sort"></fa>
          Order By: {{getSortOrderName()}}
          <fa name="fa fa-chevron-down"></fa>
        </button>

        <div *dropdownMenu class="drop-menu dropdown-menu-right" style="width: 200px;">
          <a class="drop-item" (click)="sortColumn('CREATED_DATE')">
            <div class="item">Create Date
              <i *ngIf="filterPreference.column === 'CREATED_DATE'"  class="fa ml-2"
                [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>

          <a class="drop-item" (click)="sortColumn('UPDATE_DATE')">
            <div class="item">Update Date
              <i *ngIf="filterPreference.column === 'UPDATE_DATE'"  class="fa ml-2"
                [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>

          <a class="drop-item" (click)="sortColumn('CLIENT')">
            <div class="item">Company Name
              <i *ngIf="filterPreference.column === 'CLIENT'"  class="fa ml-2"
                [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>

          <a class="drop-item" (click)="sortColumn('ENGAGED_DATE')">
            <div class="item">Engaged Date
              <i *ngIf="filterPreference.column === 'ENGAGED_DATE'"  class="fa ml-2"
                [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>

          <a class="drop-item" (click)="sortColumn('DUE_DATE')">
            <div class="item">Due Date
              <i *ngIf="filterPreference.column === 'DUE_DATE'"  class="fa ml-2"
                [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>

          <a class="drop-item" (click)="sortColumn('FOLLOW_UP_DATE')">
            <div class="item">Follow Up Date
              <i *ngIf="filterPreference.column === 'FOLLOW_UP_DATE'"  class="fa ml-2"
                 [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>

          <a class="drop-item" (click)="sortColumn('STAGE')">
            <div class="item">State / Stage
              <i *ngIf="filterPreference.column === 'STAGE'"  class="fa ml-2"
                [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>
          <a class="drop-item" (click)="sortColumn('PROGRESS')">
            <div class="item">Progress
              <i *ngIf="filterPreference.column === 'PROGRESS'"  class="fa ml-2"
                [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>
          <a class="drop-item" (click)="sortColumn('ASSIGNEE')">
            <div class="item">Assignee
              <i *ngIf="filterPreference.column === 'ASSIGNEE'"  class="fa ml-2"
                [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
            </div>
          </a>
           <a class="drop-item" (click)="sortColumn('BANK')">
             <div class="item">Bank
              <i *ngIf="filterPreference.column === 'BANK'"  class="fa ml-2"
              [ngClass]="{'fa-sort-amount-desc': filterPreference.isDesc, 'fa-sort-amount-asc': !filterPreference.isDesc}"></i>
             </div>
           </a>
        </div>
      </div>

      <!-- Save Filter Button -->
      <button (click)="onSavePreference()" [disabled]="(preference && !filterPreference.isChanged) || reportsLoading" type="button"
        [ngClass]="{'warning': filterPreference.isChanged}" class="btn btn-rbv hinted btn-rbv-small"
        style="margin-left: 5px; padding-top: 2px;">
        <fa name="fa fa-floppy-o" style="margin-right: 5px;"></fa> Filters <span *ngIf="filterPreference.isChanged">*</span>
        <div *ngIf="filterPreference.isChanged" class="hint">Save Filters Changes</div>
        <div *ngIf="!filterPreference.isChanged" class="hint">Save Filters</div>
      </button>
    </div>
  </div>
</div>
